export default __webpack_public_path__ + "static/media/sweets2.027689de.jpg";